import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';

const TopNav = ({ toggleSidebar }) => {
  const [countdown, setCountdown] = useState({ days: 14, hours: 8, minutes: 45, seconds: 0 });

  // Dummy countdown effect
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        let { days, hours, minutes, seconds } = prev;
        seconds--;
        if (seconds < 0) { seconds = 59; minutes--; }
        if (minutes < 0) { minutes = 59; hours--; }
        if (hours < 0) { hours = 23; days--; }
        return { days, hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="h-16 glass-panel border-b border-slate-800 flex items-center justify-between px-4 md:px-6 z-20 sticky top-0">
      <div className="flex items-center">
        <button onClick={toggleSidebar} className="md:hidden text-slate-400 hover:text-ice mr-4">
          <SafeIcon name="Menu" className="text-2xl" />
        </button>
        <div className="flex flex-col">
          <span className="text-[10px] font-mono text-rocket-500 tracking-widest uppercase">Current Mission</span>
          <h1 className="text-sm md:text-base font-semibold text-ice flex items-center">
            Project Nebula v2.0
            <span className="ml-2 px-2 py-0.5 rounded text-[10px] bg-slate-800 text-slate-300 border border-slate-700">Q3 Release</span>
          </h1>
        </div>
      </div>

      <div className="flex items-center space-x-4 md:space-x-8">
        {/* Countdown Strip */}
        <div className="hidden md:flex items-center space-x-3 bg-slate-900/80 px-4 py-1.5 rounded border border-slate-800 shadow-[inset_0_0_10px_rgba(0,0,0,0.5)]">
          <SafeIcon name="Clock" className="text-rocket-500 text-sm" />
          <div className="flex space-x-2 font-mono text-sm">
            <span className="text-ice">T-MINUS</span>
            <span className="text-rocket-400 font-bold w-6 text-center">{countdown.days}d</span>
            <span className="text-slate-500">:</span>
            <span className="text-ice w-5 text-center">{countdown.hours.toString().padStart(2, '0')}</span>
            <span className="text-slate-500">:</span>
            <span className="text-ice w-5 text-center">{countdown.minutes.toString().padStart(2, '0')}</span>
            <span className="text-slate-500">:</span>
            <span className="text-rocket-500 w-5 text-center">{countdown.seconds.toString().padStart(2, '0')}</span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-3">
          <button className="relative p-2 text-slate-400 hover:text-ice transition-colors">
            <SafeIcon name="Bell" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-rocket-500 rounded-full"></span>
          </button>
          <div className="w-8 h-8 rounded bg-gradient-to-br from-rocket-600 to-slate-800 border border-slate-700 flex items-center justify-center text-sm font-bold text-ice cursor-pointer">
            MC
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopNav;